import useListings from 'api/listing/useListings';
import { NormalizedPublicListing } from 'types/listingV3';
import {
  formatListingsToGroupActivateByDate,
  useListingsV2Params,
} from 'utils/listingsHelpers';
import { useLandingPageAnalyticsView } from './useLandingPageAnalyticsView';

interface UseAllProductsLandingListingsResult {
  readonly isError: boolean;
  readonly isLoading: boolean;
  /** Listings already prepared for display — Activate rows grouped by date, one card per event
      (never per session), which is what both AllProductsLandingPage variants render. */
  readonly listings: NormalizedPublicListing[];
  readonly loadMore: () => void;
}

/**
 * Data layer for AllProductsLandingPage and its ScheduleView variant. Fetches the listings
 * feed, wires the landing-page analytics tracker, and groups Activate sessions by date for
 * display. Both variants share this pipeline verbatim — the only difference between them is
 * what they render around the results.
 */
const useAllProductsLandingListings =
  (): UseAllProductsLandingListingsResult => {
    const params = useListingsV2Params();
    const { listings, loadMore, isLoading, isError } = useListings({
      v2Params: params,
      v3Params: {
        ...params,
        isUnlisted: params.isUnlisted === 'true',
      },
    });

    useLandingPageAnalyticsView({
      listings,
      isReadyToTrackAnalytics: !isLoading,
    });

    return {
      isError,
      isLoading,
      listings: formatListingsToGroupActivateByDate(listings, false),
      loadMore,
    };
  };

export default useAllProductsLandingListings;
